<template>
  <div class="diy-card-catalogue__card-actions">
    <CardCatalogueCardActionsAdd :card="card" />
  </div>
</template>

<script>
// Components
import CardCatalogueCardActionsAdd from './CardCatalogueCardActionsAdd'

export default {
  name: 'CardCatalogueCardActions',

  components: {
    CardCatalogueCardActionsAdd,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.diy-card-catalogue__card-actions >>> .submit-button .app-button:hover {
  background-color: var(--c-primary);
}

/* Responsive --------- */
@media (min-width: 681px) {
  .diy-card-catalogue__card-actions >>> .submit-button {
    max-width: unset;
    min-width: 101px;
  }
}
</style>
